<template>
    <router-view @auth="updateAuthStatus" @toast="showToast" :key="$route.fullPath" @navigation="navChange"/>
  </template>

<script>
  export default {
    data: () => ({}),
    created() {},
    methods: {
      updateAuthStatus(isAuth) {
          this.$emit("auth", isAuth);
      },
      showToast(type, message) {
          this.$emit("toast", type, message);
      },
      navChange(show) {
        console.log('emit');
        this.$emit("navigation", show);
      }
    },
  };
</script>